import { render, staticRenderFns } from "./confirm-change.scene.vue?vue&type=template&id=67900b43"
import script from "./confirm-change.scene.ts?vue&type=script&lang=ts&external"
export * from "./confirm-change.scene.ts?vue&type=script&lang=ts&external"
import style0 from "./confirm-change.scene.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports